import { env } from "../../config/env";

export const IDENTITY_REDIRECT_FLAG = "chmforms.identity.redirected";

export function getIdentityLoginUrl(returnUrl: string): string {
  try {
    const url = new URL(env.identityLoginUrl);
    url.searchParams.set("redirect", returnUrl);
    return url.toString();
  } catch {
    const separator = env.identityLoginUrl.includes("?") ? "&" : "?";
    return `${env.identityLoginUrl}${separator}redirect=${encodeURIComponent(returnUrl)}`;
  }
}

export function clearIdentityRedirectFlag(): void {
  try {
    sessionStorage.removeItem(IDENTITY_REDIRECT_FLAG);
  } catch {
    // Storage may be unavailable in private mode.
  }
}

export function markIdentityRedirectAttempted(): void {
  try {
    sessionStorage.setItem(IDENTITY_REDIRECT_FLAG, "1");
  } catch {
    // LoginPage всё равно остаётся доступна для ручного входа.
  }
}
